import * as React from 'react';
import { useSelector } from 'react-redux';
import { onboardingSelector } from '../../../../reducers/onboarding';
import { SingleSelect } from '../../../../widgets/FormikInputFieldV2';

const useSiteOptions = (includeFinalized: boolean) => {
  const sites = useSelector(onboardingSelector.getSites);
  const options = React.useMemo(
    () =>
      Object.entries(sites)
        .filter(([, site]) => includeFinalized || !site.finalized)
        .map(([uuid, site]) => ({
          label: site.name,
          value: uuid,
        })),
    [includeFinalized, sites],
  );
  return { sites, options };
};

const NO_OPTION_MESSAGE = () => 'No available sites';

type Props = {
  name: string;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  className?: string;
  id?: string;
  /**
   * by default, finalized sites are excluded from the option list
   */
  includeFinalized?: boolean;
};
export const SiteSelect: React.FunctionComponent<Props> = ({
  disabled,
  name,
  label,
  required,
  className,
  id,
  includeFinalized = false,
}) => {
  const { options } = useSiteOptions(includeFinalized);
  return (
    <SingleSelect
      name={name}
      placeholder="Choose a site"
      noOptionsMessage={NO_OPTION_MESSAGE}
      options={options}
      className={className}
      label={label}
      required={required}
      isDisabled={disabled}
      classNamePrefix={id}
      id={id}
    />
  );
};
